import { routing_utils_match_and_extract_params_v3 } from "./frfr-routing-utils";
// import { js_utils } from "./frfr-js-utils";
// import { json_utils } from "./frfr-json-utils";




// const frfr_lib_changes_id = '/FRFR/frfr-viarouter69-utils.js/changes_id2026-02-09r1/';



// FRFR UNDER CONSTRUCTION FRFR TODO
/* 
FrFr FRIENDLY FRAMEWORK
frfr-viarouter69-utils.js
Version ID: 1a 2026-02-09r1
by 
// Please describe here if you customized this file
*/


//

////

/*
- next() is called usually when when middleware just preprare something for next middlewares or when check something and then call next conditionaly.


method
.execute_routing_and_return_val



special_instance_obj = {
  returned_value // defualt undefined


  originalUrl

  TODO popisati sve metode i propertije od req obj


};
*/


//
const SLASH = '/';
const WILDCARD = '*'; // matches zero or more characters
// const QUESTIONMARK = '?'; // matches single character
const COLON = ':';

//
// const viarouter69_engine = {};
// const viarouter69_init_engine = () => { };


// IRDO - intermediate (semi-finished) routing data object
const irdo_state_create = (url_path, is_sub = false, parent_irdo_istate = null) => {
  // IRDO - intermediate routing data object - semi-finished
  let irdo_istate = {
    readme: 'this is IRDO - intermediate (semi-finished) routing data object',
    original_url_path: url_path,
    url_path: url_path,
    path_params: {}, // url query params
    getmethod_params: {}, // url query params
    //
    is_match: false,
    is_match_full: false,
    is_match_prefix: false,
    path_original: null, // TODO
    path_prefix: null, //
    path_sufix: null, // path sufix for subrouter
    params: {}, // path params
    query: {}, // url query params
    //
    //
    router_instance_ref: null,
    parent_irdo_ref: null,
    routes_ref: null,
    current_index: 0, // TODO -1
    req: {
      user_shared_data: {
        readme: 'add data req.user_shared_data to pass them to other middlewares',
      },
    },
    res: {
      locals: {} // res.locals object stores variables specific to the current request-response cycle. Scope: Limited to the single request. Once the response is sent, the data is cleared. Usage: Ideal for request-specific information like the authenticated user's details, flash messages, or data fetched from a database for a specific page.
    },
    shared_data: {},
    //
    status_is_finished: false,
    status_is_finished_with_succes: null,
    status_is_finished_with_fail: null,
    path_original: url_path,
    stats: {
      level: 0,
      consumed_routes_count: 0,
      executed_middlewares_count: 0,
    }
  };
  if (is_sub === true) {
    irdo_istate.is_sub = true;
    irdo_istate.parent_irdo_ref = parent_irdo_istate;
    irdo_istate.req = { ...parent_irdo_istate.req }; // TODO 
    irdo_istate.req.path = url_path; // TODO 
  } else {
    irdo_istate.req.originalUrl = url_path; // TODO 
    irdo_istate.req.original_path = url_path; // TODO
  }
  return irdo_istate;
};


//
const _standalone_execute_as_subrouter = (subrouter_instance, parent_irdo_istate) => {
  const path_sufix = parent_irdo_istate.path_sufix;
  const sub_irdo_istate = irdo_state_create(path_sufix, true, parent_irdo_istate.req);
  // sub_irdo_istate.is_sub = true;
  // sub_irdo_istate.parent_irdo_ref = parent_irdo_istate;
  sub_irdo_istate.router_instance_ref = subrouter_instance;
  sub_irdo_istate.stats.level = sub_irdo_istate.stats.level + 1;
  // sub_irdo_istate = _standalone_single_iteration(sub_irdo_istate);
  // subrouting return only irdo
  return _standalone_single_iteration(sub_irdo_istate);
};


//
const _standalone_single_iteration = (irdo_istate) => {
  let is_next_called = false;
  let bingo = false;
  // let continue_iterations = true;
  let continue_iterations = false;
  const current_index = irdo_istate.current_index;
  const router_instance_ref = irdo_istate.router_instance_ref;
  if (Array.isArray(router_instance_ref.routes) && router_instance_ref.routes[current_index]) {
    const single_route = router_instance_ref.routes[current_index];
    const pattern = single_route.pattern;
    irdo_istate.stats.consumed_routes_count = irdo_istate.stats.consumed_routes_count + 1;
    irdo_istate.stats.executed_middlewares_count = irdo_istate.stats.executed_middlewares_count + 1; // TODO
    if (single_route.type_is_route === true) { // CASE same level router
      const path = irdo_istate.url_path;
      const matching_pack = routing_utils_match_and_extract_params_v3(path, pattern);
      // console.log('matching_pack', matching_pack);
      if (matching_pack.is_match_full === true) { // BINGO match route full
        bingo = true; // prevent another bingo
        const handler = single_route.handler;
        // we extract params in regular routes only when matching is full
        irdo_istate.params = { ...irdo_istate.params, ...matching_pack.params };
        irdo_istate.req.params = irdo_istate.params; // TODO
        const next = () => { // TODO
          is_next_called = true;
          /* TODO */
        };
        const _temp_ref = {
          returned_value: handler(irdo_istate.req, irdo_istate.res, next),
        };
        router_instance_ref.returned_value = _temp_ref.returned_value;
        irdo_istate.returned_value = _temp_ref.returned_value;
        irdo_istate.status_is_finished = true; // FINISHED
        irdo_istate.status_is_finished_with_succes = true; // DONE
        console.log('irdo_istate', irdo_istate);
        continue_iterations = false;
      } else { // FAIL TO MATCH SNGLE ROUTE BUT CONTINUE ITERATIONS
        /*
        irdo_istate.status_is_finished = true; // FINISHED
        irdo_istate.status_is_finished_with_fail = true; // FAIL
        continue_iterations = false;
        */
        continue_iterations = true;
      }
    } else if (single_route.type_is_via === true) { // CASE subrouter
      const subrouter_instance = single_route.subrouter_ref;
      const child_irdo_istate = _standalone_execute_as_subrouter(subrouter_instance, irdo_istate);
      if (child_irdo_istate.is_finished) {
        /*
        irdo_istate.is_finished = true;
        irdo_istate.status_is_finished_with_succes = child_irdo_istate.status_is_finished_with_succes;
        irdo_istate.status_is_finished_with_fail = child_irdo_istate.status_is_finished_with_fail;
        continue_iterations = false;
        */
        /*
        In Express, if a request matches a mounted subrouter but no route inside that subrouter matches, Express keeps looking for the next matching handler after that subrouter.

        So if thing do not end in subrouter, we can have another subrouter later with same pattern?
        Yes - you can mount another subrouter later with the same base path, and Express will try them in order. If the first subrouter does not send a response and calls next(), the request continues to the next matching middleware/router in the stack.
        */
      }
    }
  } else { // CASE no more router to iterate
    // continue_iterations stay false
  }
  console.log('continue_iterations', continue_iterations);
  if (continue_iterations === true) { // continue loop...
    irdo_istate.current_index = irdo_istate.current_index + 1;
    _standalone_single_iteration(irdo_istate); // next iteration
  } else { // FINISH ITERATIONS
    router_instance_ref.is_finished = irdo_istate.status_is_finished;
    router_instance_ref.status_is_finished_with_succes = irdo_istate.status_is_finished_with_succes;
    // router_instance_ref.status_is_finished_with_fail = irdo_istate.status_is_finished_with_fail;
    // router_instance_ref.returned_value = irdo_istate.returned_value;
    if (irdo_istate.status_is_finished_with_succes === true) {
      router_instance_ref.status_is_finished_with_fail = irdo_istate.status_is_finished_with_fail;
      router_instance_ref.returned_value = irdo_istate.returned_value;
    } else {
      router_instance_ref.status_is_finished_with_fail = true;
      // router_instance_ref.returned_value = irdo_istate.returned_value;
    }
    // return to parent
    return irdo_istate;
  }
};


// VIAROUTER SPECIAL INSTANCE (USING ENGINE)
// Every instance just storing database key and settings. All operation are done by same only engine.
export const viarouter69_create_v3b = function (url) {
  const instance = {}; // new router instance...
  instance.thisis = 'VIAROUTER69_INSTANCE';
  instance.status = 'PENDING';
  instance.is_finished = false;
  instance.status_is_finished_with_succes = null;
  instance.status_is_finished_with_fail = null;
  instance.returned_value = undefined; // TODO
  //
  instance.routes = []; // routes, middlewares, subRouters...
  // instance.subrouters = []; // via routers

  instance.addRoute = (pattern, handler) => {
    // this.routes.push({ method: 'GET', pattern, handler });
    if (typeof pattern === 'string' && typeof handler === 'function') {
      instance.routes.push({ method: 'GET', pattern, handler, type_is_route: true });
    }
  };

  // NEW: Express-style .use() for subrouters
  /*
  use(prefix, subRouter) {
    this.subrouters.push({ prefix, router: subRouter });
  }
  */
  instance.viaSubrouter = (pattern, subrouter) => {
    // instance.subrouters.push({ prefix, subrouter_ref: subrouter });
    if (typeof pattern === 'string' && subrouter && subrouter.thisis === 'VIAROUTER69_INSTANCE') {
      instance.routes.push({ method: 'GET', pattern, subrouter, type_is_via: true });
    }
  };

  //
  instance.is_success = () => { // TODO
    // if (instance.status === 'DONE') {
    if (instance.status_is_finished_with_succes === true) {
      return true;
    } else {
      return false;
    }
  };

  instance.get_returned_value = (default_val) => {
    if (instance.status_is_finished_with_succes === true) {
      // return instance.returned_value;
      return [instance.returned_value, true];
    } else { // if not succes return deefault value
      // return default_val;
      return [default_val, false];
    }
  };

  // execute as root router
  instance.execute = (path, default_val) => {
    console.log('router.execute(path)', path)
    const irdo_istate = irdo_state_create(path);
    irdo_istate.router_instance_ref = instance;
    // irdo_istate.stats.level = irdo_istate.stats.level + 1;
    irdo_istate.stats.level = 1;
    _standalone_single_iteration(irdo_istate);
    return instance;
  };
  //
  return instance; // you can chain .get_returned_value();
};


//

